import { useState } from 'react'

export const useBasketForm = () => {
  const [isLoadingOrder, setIsLoadingOrder] = useState(false)
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [phone, setPhone] = useState('')
  const [cityRef, setCityRef] = useState('')
  const [warehouseRef, setWarehouseRef] = useState('')
  const [house, setHouse] = useState('')
  const [apartment, setАpartment] = useState('')
  const [countryHouse, setCountryHouse] = useState('')
  const [middleName, setMiddleName] = useState('')
  const [email, setEmail] = useState('')
  const [internationalCity, setInternationalCity] = useState('')
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [citiesPage, setCitiesPage] = useState(1)
  const [citiesSearch, setCitiesSearch] = useState('')
  const [warehousePage, setWarehousePage] = useState(1)
  const [warehouseSearch, setWarehouseSearch] = useState('')
  const [showWarehouses, setShowWarehouses] = useState(false)
  const [showCities, setShowCities] = useState(false)
  const [country, setCountry] = useState('')
  const [cityID, setCityId] = useState('1')
  const [cityName, setCityName] = useState('')
  const [warehouseName, setWarehouseName] = useState('')

  const [firstNameError, setNameError] = useState(false)
  const [lastNameError, setLastNameError] = useState(false)
  const [phoneError, setPhoneError] = useState(false)
  const [cityError, setCityError] = useState(false)
  const [warehouseError, setWarehousesError] = useState(false)
  const [middleNameError, setMiddleNameError] = useState(false)
  const [houseError, setHouseError] = useState(false)
  const [kwartiraError, setKvartiraError] = useState(false)
  const [emailError, setEmailError] = useState(false)
  const [internationalCityError, setInternationalCityError] = useState(false)
  const [errorStreenInternational, setErrorStreenInternational] = useState(false)

  const validate = (deliveryMethod: string): boolean => {
    let valid = true

    if (!firstName) {
      setNameError(true)
      valid = false
    }

    if (!lastName) {
      setLastNameError(true)
      valid = false
    }

    if (!phone) {
      setPhoneError(true)
      valid = false
    }
    if (!cityRef && deliveryMethod !== 'novaposhta.international') {
      setCityError(true)
      valid = false
    }

    if (!warehouseRef && deliveryMethod === 'cod') {
      setWarehousesError(true)
      valid = false
    }

    if (deliveryMethod === 'novaposhta.courier') {
      if (!cityID){
        setCityError(true)
        valid = false
      }
      if (!house) {
        setHouseError(true)
        valid = false
      }

      if (!apartment) {
        setKvartiraError(true)
        valid = false
      }
    }

    if (deliveryMethod === 'novaposhta.international') {
      if (!email) {
        setEmailError(true)
        valid = false
      }

      if (!internationalCity) {
        setInternationalCityError(true)
        valid = false
      }

      if (!middleName) {
        setMiddleNameError(true)
        valid = false
      }

      if (!countryHouse) {
        setErrorStreenInternational(true)
        valid = false
      }

      if(!country){
        setErrorStreenInternational(true)
        valid = false
      }
    }

    return valid
  }

  return {
    state: {
      isLoadingOrder,
      firstName,
      lastName,
      phone,
      cityRef,
      warehouseRef,
      house,
      apartment,
      countryHouse,
      middleName,
      firstNameError,
      lastNameError,
      phoneError,
      isOpenModal,
      citiesPage,
      citiesSearch,
      cityError,
      warehousePage,
      warehouseSearch,
      warehouseError,
      showWarehouses,
      showCities,
      country,
      middleNameError,
      cityID,
      errorStreenInternational,
      houseError,
      kwartiraError,
      email,
      emailError,
      internationalCity,
      internationalCityError,
      cityName,
      warehouseName,
    },

    setters: {
      setIsLoadingOrder,
      setFirstName,
      setLastName,
      setPhone,
      setCityRef,
      setWarehouseRef,
      setHouse,
      setАpartment,
      setCountryHouse,
      setMiddleName,
      setNameError,
      setLastNameError,
      setPhoneError,
      setIsOpenModal,
      setCitiesPage,
      setCitiesSearch,
      setCityError,
      setWarehousePage,
      setWarehouseSearch,
      setWarehousesError,
      setShowWarehouses,
      setShowCities,
      setCountry,
      setMiddleNameError,
      setCityId,
      setErrorStreenInternational,
      setHouseError,
      setKvartiraError,
      setEmail,
      setEmailError,
      setInternationalCity,
      setInternationalCityError,
      setCityName,
      setWarehouseName,
    },

    validate,
  }
}
